import { Link } from "../router/router";
import { PageHead } from "./page-head";

export function NotFound() {
  return (
    <>
      <PageHead title="Nicht gefunden" />
      <div className="pf-empty">Diese Seite gibt es nicht. <Link to="/">Zur Übersicht</Link></div>
    </>
  );
}
